// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
require('./_set-collection-from')('Set');



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/modules/es7.set.from.js